import {useState} from "react";
import {useLocation, useNavigate} from "react-router";
import Header from "../../Components/Header";
import withUserAuth from "../../Behavior/withUserAuth";
import {addTax, updateTax} from "../../API";
import ErrorDialog from "../../Components/ErrorDialog";
import Loader from "../../Components/Loader";
import {MENUS} from "../../constants";
import SideMenu from "../../Components/SideMenu";

const Tax = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const state = location.state || {};

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [name, setName] = useState(() => {
        if (state.tax) {
            return state.tax.name;
        }
        return '';
    });
    const [rate, setRate] = useState(() => {
        if (state.tax) {
            return state.tax.tax;
        }
        return '';
    })

    const handleSave = async () => {
        let res;
        setLoading(true);
        if (state.tax) {
            res = await updateTax({...state.tax, name, tax: rate});
        } else {
            res = await addTax({name, tax: rate});
        }
        setLoading(false);
        if (res.code === 200) {
            navigate(-1);
        } else {
            setError(res.error);
        }

    }
    return (
        <>
            {loading && <Loader/>}
            {!!error && <ErrorDialog isOpen={true} content={error} onClose={() => setError('')}/>}
            <Header title={"Tax"} hasBack/>
            <SideMenu selected={MENUS.SETTINGS}/>
            <div id="appCapsule">
                <div className="section item-amend-category mt-2">
                    {/* Set Name */}
                    <div className="card card-border">
                        <div className="card-body">
                            <form>
                                <div className="form-group basic">
                                    <div className="input-wrapper">
                                        <label className="label" htmlFor="taxName">Tax Name</label>
                                        <input type="text" value={name} onChange={(e) => setName(e.target.value)}
                                               className="form-control" id="taxName"/>
                                        <i className="clear-input">
                                            <ion-icon name="close-circle"/>
                                        </i>
                                    </div>
                                </div>
                                <div className="form-group basic">
                                    <div className="input-wrapper">
                                        <label className="label" htmlFor="taxRate">Tax Rate</label>
                                        <input type="text" value={rate} onChange={(e) => setRate(e.target.value)}
                                               className="form-control" id="taxRate"/>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    {/* * Set Name */}
                    <div className="mt-4">
                        <a onClick={handleSave} className="btn btn-primary btn-shadow btn-lg btn-block">Save</a>
                    </div>
                </div>
            </div>
        </>
    )
}

export default withUserAuth(Tax);
